var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.docInfo.text)?_c('span',{class:{
    'red--text': _vm.docInfo.alert === 1,
    'blue-dark--text': _vm.docInfo.alert === 2
  }},[_vm._v(_vm._s(_vm.docInfo.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }